import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_FlowSheet } from '../../../../../_entity/flow-sheet/ModuleFE_FlowSheet.js';
import './Renderer_FlowSheetHeader.scss';
export class Renderer_FlowSheetHeader extends ComponentSync {
    __onFlowSheetsUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.flowSheet?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ flowSheet: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.flowSheet?._id)
            state.flowSheet = ModuleFE_FlowSheet.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'flow-sheet-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'flow-sheet-header__title', children: this.state.flowSheet?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const flowSheet = this.state.flowSheet;
        if (!flowSheet?.description)
            return;
        return _jsx("span", { className: 'flow-sheet-header__sub-title', children: flowSheet.description });
    };
}
//# sourceMappingURL=Renderer_FlowSheetHeader.js.map